module.exports = __webpack_public_path__ + "img/tj.1cbf3f86.svg";